// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-tags-container[data-v-d22b3d80]{padding:.5rem .25rem;display:block}.filterContainer[data-v-d22b3d80]{z-index:unset}.display-more-text[data-v-d22b3d80]{font-style:oblique}.info-tags-items[data-v-d22b3d80]{display:grid;grid-template-columns:1fr 3fr}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
